/** Matches backend: meetings.zoom_duration_minutes must be >= this to allow status Completed (India CRM only). */
export const MIN_ZOOM_MINUTES_FOR_COMPLETED = 30;

/**
 * Only sales_executive and interviewer must satisfy Zoom duration before Completed (admins bypass).
 * France CRM: no duration check for any role.
 */
export function zoomDurationRequiredToCompleteMeeting(userRole, crmCountry) {
  if (String(crmCountry || '').toUpperCase() === 'FRANCE') {
    return false;
  }
  const r = String(userRole || '').toLowerCase();
  return r === 'sales_executive' || r === 'interviewer';
}

/**
 * @param {object} meeting — row from API (needs zoom_duration_minutes from Zoom sync)
 * @param {string} [userRole] — logged-in user role; admins bypass duration check
 * @param {string} [crmCountry] — active CRM country (`INDIA` | `FRANCE`); France skips duration
 * @returns {boolean}
 */
export function canMarkMeetingCompleted(meeting, userRole, crmCountry) {
  if (!zoomDurationRequiredToCompleteMeeting(userRole, crmCountry)) {
    return true;
  }
  const d = meeting?.zoom_duration_minutes;
  return d != null && Number(d) >= MIN_ZOOM_MINUTES_FOR_COMPLETED;
}

export function meetingCompletedBlockedMessage() {
  return `Completed requires Zoom meeting duration of at least ${MIN_ZOOM_MINUTES_FOR_COMPLETED} minutes. Sync the meeting from the list (Sync) so duration is saved, then try again.`;
}
